
import { createContext } from 'react';
export const RechargeContext = createContext();
